import React from "react"
import styled from "styled-components"

const nm = {
  bg: "#e0e5ec",
  shadowOut: "6px 6px 12px #b8bec7, -6px -6px 12px #ffffff",
  shadowIn:  "inset 3px 3px 7px #b8bec7, inset -3px -3px 7px #ffffff",
}

export default function Footer() {
  return (
    <Wrapper>
      <Inner>
        <Name>Tianyu (Steve) Wang</Name>
        <Buttons>
          <PrimaryBtn href="#publications">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>
            View Research
          </PrimaryBtn>

          <IconBtn href="https://x.com/VisionSteve" target="_blank" rel="noopener noreferrer" aria-label="X / Twitter">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </IconBtn>

          <IconBtn href="https://instagram.com/steve.wong.film" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
            </svg>
          </IconBtn>

          <IconBtn href="https://scholar.google.com/citations?user=yRwZIN8AAAAJ" target="_blank" rel="noopener noreferrer" aria-label="Google Scholar">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 24a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-24L0 9.5l4.838 3.94A8 8 0 0 1 12 10a8 8 0 0 1 7.162 3.44L24 9.5 12 0z"/>
            </svg>
          </IconBtn>

          <IconBtn href="mailto:steve.w.vision@icloud.com" aria-label="Email">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
            </svg>
          </IconBtn>
        </Buttons>
        <Copy><a href="https://research.adobe.com/person/tianyu-steve-wang/">Adobe profile</a> · <a href="https://github.com/stevewongv">GitHub</a></Copy>
        <Copy>© {new Date().getFullYear()} Tianyu Wang</Copy>
      </Inner>
    </Wrapper>
  )
}

const Wrapper = styled.footer`
  background: ${nm.bg};
  padding: 60px 24px 48px;
  display: flex;
  justify-content: center;
`
const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 480px;
  width: 100%;
`
const Name = styled.p`
  font-family: bree, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #2d3436;
  letter-spacing: 0.06em;
  margin: 0;
`
const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
`
const base = `
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${nm.shadowOut};
  background: ${nm.bg};
  border: none;
  border-radius: 14px;
  cursor: pointer;
  text-decoration: none;
  color: #4a5568;
  transition: box-shadow 0.2s, color 0.2s;
  &:hover {
    box-shadow: ${nm.shadowIn};
    color: #2d3436;
  }
`
const PrimaryBtn = styled.a`
  ${base}
  gap: 8px;
  padding: 12px 20px;
  font-family: bree, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
`
const IconBtn = styled.a`
  ${base}
  width: 44px;
  height: 44px;
`
const Copy = styled.p`
  font-family: 'Courier New', Courier, monospace;
  font-size: 11px;
  color: #b2bec3;
  margin: 0;
`
